import { useQuery } from "@tanstack/react-query"
import TasksAdminService from "services/admin/tasksService"

export const useGetTasks = (queryParams: any = {}, options: { enabled?: boolean } = {}) => {
    return useQuery({
        enabled: options.enabled ?? true,
        queryKey: ['tasks', queryParams],
        queryFn: async () => {
            const response = await TasksAdminService.getAllAndCount(queryParams)
            return response.data
        },
    })
}